import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated' && err.name !== 'NavigationCancelled' && !String(err).includes('Redirected')) throw err
  })
}

const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated' && err.name !== 'NavigationCancelled' && !String(err).includes('Redirected')) throw err
  })
}

function view(name) {
  return () => import(`@/views/${name}`)
}

const router = new Router({
  mode: 'hash',
  routes: [
    { path: '/login', name: 'Login', component: view('Login'), meta: { title: '登录' } },
    { path: '/', name: 'Dashboard', component: view('Dashboard'), meta: { title: '控制台' } },

    // 1 业务管理 - 自产
    { path: '/sales/project', name: 'SalesProject', component: view('sales/ProjectList'), meta: { title: '自产项目' } },
    { path: '/sales/contract', name: 'SalesContract', component: view('sales/ContractList'), meta: { title: '销售合同' } },
    { path: '/sales/out', name: 'SalesOut', component: view('sales/SalesOut'), meta: { title: '销售出库' } },
    { path: '/sales/return', name: 'SalesReturn', component: view('sales/SalesReturn'), meta: { title: '销售退货' } },

    // 1 业务管理 - 受托
    { path: '/custom/contract', name: 'CustomContract', component: view('custom/ContractList'), meta: { title: '受托合同' } },
    { path: '/custom/out', name: 'CustomSalesOut', component: view('custom/SalesOut'), meta: { title: '受托出库' } },
    { path: '/custom/return', name: 'CustomSalesReturn', component: view('custom/SalesReturn'), meta: { title: '受托退货' } },

    // 2 采购管理
    { path: '/purchase/plan', name: 'PurchasePlan', component: view('purchase/PurchasePlan'), meta: { title: '采购计划' } },
    { path: '/purchase/order', name: 'PurchaseOrder', component: view('purchase/PurchaseOrder'), meta: { title: '采购订单' } },
    { path: '/purchase/in', name: 'PurchaseIn', component: view('purchase/PurchaseIn'), meta: { title: '采购入库' } },
    { path: '/purchase/return', name: 'PurchaseReturn', component: view('purchase/PurchaseReturn'), meta: { title: '采购退货' } },

    // 3 生产管理
    { path: '/production/plan', name: 'ProductionPlan', component: view('production/PlanForm'), meta: { title: '排产计划' } },
    { path: '/production/material-plan', name: 'MaterialPlan', component: view('production/MaterialPlan'), meta: { title: '物料计划' } },
    { path: '/production/pick', name: 'PickMaterial', component: view('production/PickMaterial'), meta: { title: '领料出库' } },
    { path: '/production/finished-in', name: 'FinishedIn', component: view('production/FinishedIn'), meta: { title: '成品入库' } },
    { path: '/production/return-material', name: 'ReturnMaterial', component: view('production/ReturnMaterial'), meta: { title: '退料入库' } },
    { path: '/production/settlement', name: 'Settlement', component: view('production/Settlement'), meta: { title: '生产结算' } },
    { path: '/production/labor', name: 'LaborRecord', component: view('production/LaborRecord'), meta: { title: '人工记录' } },
    { path: '/production/entry', name: 'EntryRecord', component: view('production/EntryRecord'), meta: { title: '入场记录' } },
    { path: '/production/ticket', name: 'TicketRecord', component: view('production/TicketRecord'), meta: { title: '领票记录' } },
    { path: '/production/office', name: 'OfficeUse', component: view('production/OfficeUse'), meta: { title: '办公室使用记录' } },

    // 4 仓库管理
    { path: '/warehouse/inventory', name: 'Inventory', component: view('warehouse/Inventory'), meta: { title: '库存台账' } },
    { path: '/warehouse/check', name: 'WarehouseCheck', component: view('warehouse/WarehouseCheck'), meta: { title: '库存盘点' } },
    { path: '/warehouse/transfer', name: 'WarehouseTransfer', component: view('warehouse/WarehouseTransfer'), meta: { title: '库存调拨' } },
    { path: '/warehouse/flow', name: 'WarehouseFlow', component: view('warehouse/WarehouseFlow'), meta: { title: '库存流水' } },
    { path: '/warehouse/transport', name: 'TransportRecord', component: view('warehouse/TransportRecord'), meta: { title: '运送记录' } },

    // 5 客户物料（档案已并入物料管理；领用/退库已并入生产管理领料出库/退料入库）
    { path: '/customer-material/incoming', name: 'Incoming', component: view('customer-material/Incoming'), meta: { title: '来料入库' } },
    { path: '/customer-material/inventory', name: 'CustomerInventory', component: view('customer-material/CustomerInventory'), meta: { title: '查询对账' } },
    { path: '/customer-material/clear-out', name: 'CustomerClearOut', component: view('customer-material/ClearOut'), meta: { title: '清库出库' } },

    // 6 报表查询
    { path: '/report/inventory', name: 'RptInventory', component: view('report/ReportInventory'), meta: { title: '库存收发存报表' } },
    { path: '/report/customer-bill', name: 'RptCustomerBill', component: view('report/ReportCustomerBill'), meta: { title: '受托生产对账单' } },
    { path: '/report/ps-ledger', name: 'RptPsLedger', component: view('report/ReportPsLedger'), meta: { title: '采购/销售台账' } },
    { path: '/report/batch-trace', name: 'RptBatchTrace', component: view('report/ReportBatchTrace'), meta: { title: '批次追踪报表' } },
    { path: '/report/progress', name: 'RptProgress', component: view('report/ReportProgress'), meta: { title: '生产进度报表' } },
    { path: '/report/quality-stat', name: 'RptQualityStat', component: view('report/ReportQualityStat'), meta: { title: '质量统计报表' } },
    { path: '/report/check-diff', name: 'RptCheckDiff', component: view('report/ReportCheckDiff'), meta: { title: '盘点差异报表' } },
    { path: '/report/material-demand', name: 'RptMaterialDemand', component: view('report/MaterialDemand'), meta: { title: '物料需求汇总表' } },
    { path: '/report/low-stock', name: 'RptLowStock', component: view('report/ReportLowStock'), meta: { title: '安全库存预警' } },
    { path: '/report/custom-project', name: 'RptCustomProject', component: view('report/ReportCustomProject'), meta: { title: '受托项目全景报表' } },

    // 6.1 财务管理
    { path: '/finance/payment', name: 'FinancePayment', component: view('finance/PaymentList'), meta: { title: '收付款记录' } },

    // 7 物料管理
    { path: '/material/category', name: 'MatCategory', component: view('material/MaterialCategory'), meta: { title: '物料分类' } },
    { path: '/material/archive', name: 'MatArchive', component: view('material/MaterialArchive'), meta: { title: '物料档案' } },

    // 8 基础数据
    { path: '/basic/warehouse', name: 'BasicWarehouse', component: view('basic/BasicWarehouse'), meta: { title: '仓库管理' } },
    { path: '/basic/workshop', name: 'BasicWorkshop', component: view('basic/BasicWorkshop'), meta: { title: '车间管理' } },
    { path: '/basic/lab', name: 'BasicLab', component: view('basic/BasicLab'), meta: { title: '实验室管理' } },
    { path: '/basic/office', name: 'BasicOffice', component: view('basic/BasicOffice'), meta: { title: '办公室管理' } },
    { path: '/basic/equipment-type', name: 'BasicEquipmentType', component: view('basic/BasicEquipmentType'), meta: { title: '设备类型' } },
    { path: '/basic/equipment', name: 'BasicEquipment', component: view('basic/BasicEquipment'), meta: { title: '设备信息' } },
    { path: '/basic/company', name: 'BasicCompany', component: view('basic/BasicCompany'), meta: { title: '往来单位' } },

    // 9 质量管理
    { path: '/quality/lab', name: 'QualityLab', component: view('quality/QualityLab'), meta: { title: '实验室使用记录' } },
    { path: '/quality/test', name: 'QualityTest', component: view('quality/QualityTest'), meta: { title: '检验记录' } },

    // 9.5 单据录入（通用表单）
    { path: '/form/record-list', name: 'FormRecordList', component: view('workflow/FormRecordList'), meta: { title: '填写记录' } },
    { path: '/form/record-fill', name: 'FormRecordFill', component: view('workflow/FormRecordFill'), meta: { title: '填写单据' } },
    { path: '/form/record-fill/:id', name: 'FormRecordEdit', component: view('workflow/FormRecordFill'), meta: { title: '编辑单据' } },

    // 10 审批工作流
    { path: '/approval/config', name: 'ApprovalConfig', component: view('approval/ApprovalConfig'), meta: { title: '审批配置' } },
    { path: '/approval/records', name: 'ApprovalRecords', component: view('approval/ApprovalRecords'), meta: { title: '审批记录' } },

    // 11 系统管理
    { path: '/system/user', name: 'SysUser', component: view('system/SysUser'), meta: { title: '用户管理' } },
    { path: '/system/dept', name: 'SysDept', component: view('system/SysDept'), meta: { title: '部门管理' } },
    { path: '/system/role', name: 'SysRole', component: view('system/SysRole'), meta: { title: '角色权限' } },
    { path: '/system/code-rule', name: 'SysCodeRule', component: view('system/SysCodeRule'), meta: { title: '编码规则' } },
    { path: '/system/params', name: 'SysParams', component: view('system/SysParams'), meta: { title: '系统参数' } },
    { path: '/system/template', name: 'SysTemplate', component: view('system/TemplateManager'), meta: { title: '模板管理' } },
    { path: '/system/log', name: 'SysLog', component: view('system/SysLog'), meta: { title: '操作日志' } },
    { path: '/system/profile', name: 'Profile', component: view('system/Profile'), meta: { title: '个人设置' } }
  ]
})

router.beforeEach((to, from, next) => {
  const raw = localStorage.getItem('profile')

  // —— 未登录 → 跳转登录页 ——
  if (!raw) {
    return to.path === '/login' ? next() : next('/login')
  }

  // —— 已登录但访问登录页 → 跳转首页 ——
  if (to.path === '/login') {
    return next('/')
  }

  // —— 页面级权限校验 ——
  try {
    const user = JSON.parse(raw)
    const menuPerm = user.menu_perm
    // menu_perm 为 null 表示系统管理员，不限制；其余（含空数组、字段缺失）按白名单校验
    if (menuPerm !== null) {
      const list = Array.isArray(menuPerm) ? menuPerm : []
      const hasPerm = (path) => list.some(p => p === path || path.startsWith(p + '/'))
      if (to.path !== '/' && !hasPerm(to.path)) {
        return next('/')
      }
    }
  } catch (e) {
    // profile 数据损坏，清除并跳转登录页
    localStorage.removeItem('profile')
    localStorage.removeItem('token')
    return next('/login')
  }

  next()
})

export default router
